import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import NumberHelper from "../../../../../lib/UniversalTable/RendererHelpers/NumberHelper";
import {
  NUMBER_WITH_PRICE_ALERT_DISPLAY_FORMAT,
  getPriceAlertNumberButtonStyle,
  getPriceAlertNumberButtonVariant,
  getPriceAlertNumberTextStyle,
  isEmptyNumberWithPriceAlertValue,
  pickNumberWithPriceAlertModalFields
} from "../../../../../lib/UniversalTable/RendererHelpers/NumberWithPriceAlertHelper";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import AlarmClockIcon from "../../../pages/SingleAnalysisPage/components/PriceAlertButton/assets/alarm-clock.svg";

const NumberWithPriceAlert = ({
  value,
  attributeName,
  resultMetaData,
  label,
  translate
}) => {
  if (isEmptyNumberWithPriceAlertValue(value)) {
    return null;
  }

  const renderedNumber = NumberHelper.render(
    value,
    NUMBER_WITH_PRICE_ALERT_DISPLAY_FORMAT
  );
  const { stockId, stockName, price, description } =
    pickNumberWithPriceAlertModalFields(resultMetaData, value, {
      label,
      translate
    });
  const showPriceAlertButton = Boolean(stockId);
  const variant = getPriceAlertNumberButtonVariant(attributeName);
  const buttonStyle = getPriceAlertNumberButtonStyle(variant);
  const textStyle = getPriceAlertNumberTextStyle(variant);

  const openPriceAlertModal = () => {
    showModal("NewPriceAlertsModal", {
      stockId,
      stockName,
      price,
      description
    });
  };

  return (
    <LandingTypography>
      <div className="flex align-center justify-end gap-2 w-full">
        <span style={textStyle}>{renderedNumber}</span>
        {showPriceAlertButton ? (
          <button
            type="button"
            className="flex align-center justify-center p-1 rounded border-none shrink-0 -my-2.5 hover:opacity-65 focus:opacity-80 active:opacity-70"
            style={buttonStyle}
            onClick={openPriceAlertModal}
            aria-label="Create price alert"
          >
            <img
              src={AlarmClockIcon}
              alt=""
              className="shrink-0"
              width={12}
              height={12}
            />
          </button>
        ) : null}
      </div>
    </LandingTypography>
  );
};

const NumberWithPriceAlertWithTranslations = withTranslations(
  NumberWithPriceAlert
);

NumberWithPriceAlertWithTranslations.shouldRenderDash = props =>
  isEmptyNumberWithPriceAlertValue(props?.value);

export default NumberWithPriceAlertWithTranslations;
